module.exports = __webpack_public_path__ + "static/img/home_productcard_cooler_mobile.d6f12889.jpg";